import { render } from "./AozoranoPlanetariumScreen.vue?vue&type=template&id=09146902&scoped=true&ts=true&lang=pug"
import script from "./AozoranoPlanetariumScreen.vue?vue&type=script&lang=ts"
export * from "./AozoranoPlanetariumScreen.vue?vue&type=script&lang=ts"

import "./AozoranoPlanetariumScreen.vue?vue&type=style&index=0&id=09146902&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09146902"]])

export default __exports__